import gql from 'graphql-tag';
import Product from '../../../entity/product';

const getProducts = gql`
  query productsByStore(
    $storeId: IDString!
    $name: String
    $before: String
    $after: String
    $first: Int
    $last: Int
    $order: ProductOrder
    $searchInput: ProductSearchInput
  ) {
    productsByStore(
      storeId: $storeId
      name: $name
      searchInput: $searchInput
      before: $before
      after: $after
      first: $first
      last: $last
      order: $order
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          ${Product.fragmentsFields()}
        }
      }
    }
  }
`;

export default getProducts;
